import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BindHomeFullscreenService {
  public filterRoomsValue: boolean = true;

  private dateSubject: Subject<Date> = new Subject<Date>();

  public day = new Date();

  private smartPlanningCache:
    | {
        dateKey: string;
        roomsSurgeonOpenings: any[];
        allHospitalsRoomsSurgeonOpenings: any[];
        typeAttributeArray: any[];
        anesthetistsCalendars: any;
        roomsBufferPrograms: any[];
      }
    | undefined;

  private consultExtraCache:
    | {
        dateKey: string;
        consultationSpecialties: any[];
        extracliniqueSpecialties: any[];
        listIdsConsultationExtraclinique: string[];
      }
    | undefined;

  setDate(newDate: Date) {
    this.dateSubject.next(newDate);
  }

  setSmartPlanningData(
    dateKey: string,
    data: {
      roomsSurgeonOpenings: any[];
      allHospitalsRoomsSurgeonOpenings: any[];
      typeAttributeArray: any[];
      anesthetistsCalendars: any;
      roomsBufferPrograms: any[];
    }
  ) {
    this.smartPlanningCache = {
      dateKey,
      ...data,
    };
  }

  getSmartPlanningData(dateKey: string) {
    if (!this.smartPlanningCache) {
      return null;
    }

    if (this.smartPlanningCache.dateKey !== dateKey) {
      return null;
    }

    return this.smartPlanningCache;
  }

  setConsultExtraData(
    dateKey: string,
    data: {
      consultationSpecialties: any[];
      extracliniqueSpecialties: any[];
      listIdsConsultationExtraclinique: string[];
    }
  ) {
    this.consultExtraCache = {
      dateKey,
      ...data,
    };
  }

  getConsultExtraData(dateKey: string) {
    if (!this.consultExtraCache) {
      return null;
    }
    if (this.consultExtraCache.dateKey !== dateKey) {
      return null;
    }
    return this.consultExtraCache;
  }

  clear() {
    this.filterRoomsValue = true;
    this.dateSubject.complete();
    this.dateSubject = new Subject<Date>();
    this.day = new Date();
  }
}
